export const DolyameIcon = () => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="101" height="16" viewBox="0 0 101 16" fill="none">
			<path d="M17.8906 0.799988H15.488V12.984H17.8906V0.799988Z" fill="white" />
			<path d="M12.728 1.48176H10.3253V13.6655H12.728V1.48176Z" fill="white" />
			<path d="M7.56533 2.2429H5.16266V14.4289H7.56533V2.2429Z" fill="white" />
			<path d="M2.40267 3.01249H0L9.15527e-06 15.2H2.40268L2.40267 3.01249Z" fill="white" />
			<path
				d="M81.3492 7.29139L77.4806 2.99009H75.2189V12.9491H77.5803V6.59506L81.1122 10.3596H81.5487L85.0199 6.59506V12.9491H87.3812V2.99009H85.1196L81.3492 7.29139Z"
				fill="white"
			/>
			<path
				d="M98.6312 2.99009L92.7784 9.46307V2.99009H90.417V12.9491H92.5804L98.4332 6.4761V12.9491H100.795V2.99009H98.6312Z"
				fill="white"
			/>
			<path
				d="M62.5 6.63423C62.5 8.21983 63.3671 9.46888 64.6981 9.99258L62.2023 12.9491H65.0926L67.3629 10.2595H69.8197V12.9491H72.181V2.99009H66.1693C63.9278 2.99009 62.5 4.52347 62.5 6.63423ZM69.8211 5.18354V8.12844H66.6071C65.5348 8.12844 64.9597 7.53075 64.9597 6.65454C64.9597 5.77832 65.5551 5.18064 66.6071 5.18064L69.8211 5.18354Z"
				fill="white"
			/>
			<path
				d="M51.5269 4.98189C51.3824 8.40697 50.6599 10.6178 49.2451 10.6178H48.891V13.0086L49.2682 13.0289C52.105 13.187 53.673 10.6976 53.9302 5.26042H57.6616V12.9491H60.0186V2.99009H51.6064L51.5269 4.98189Z"
				fill="white"
			/>
			<path
				d="M42.638 2.85095C39.4443 2.85095 37.1465 5.0618 37.1465 7.96899C37.1465 10.9763 39.6466 13.1088 42.638 13.1088C45.7537 13.1088 48.1743 10.8573 48.1743 7.96899C48.1743 5.08066 45.7537 2.85095 42.638 2.85095ZM42.638 10.718C40.833 10.718 39.6032 9.54298 39.6032 7.96899C39.6032 6.35582 40.8345 5.21268 42.638 5.21268C44.4415 5.21268 45.7133 6.40804 45.7133 7.96899C45.7133 9.52993 44.4242 10.718 42.638 10.718Z"
				fill="white"
			/>
			<path
				d="M34.6421 3.00888H26.308L26.2285 5.00068C26.11 7.87014 25.3614 10.5989 23.9466 10.6381L23.292 10.6584V15.2001L25.6736 15.1953V12.9505H33.947V15.1953H36.3488V10.6381H34.6421V3.00888ZM32.2808 10.6381H27.2416C28.0942 9.34404 28.5508 7.4712 28.6303 5.28066H32.2808V10.6381Z"
				fill="white"
			/>
		</svg>
	)
}
